// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IdRP","placeholdersHeader":"styles_placeholdersHeader__dYYJ6","editorStyle":"styles_editorStyle__1elhD","placeholdersBox":"styles_placeholdersBox__26E2L"};